import type { ToolUseItem } from '../../../../contracts/harness.types';

import { objectWriteFor } from '../object-card/objectWrites';
import { resolveToolPresentation } from './tool-registry';
import type { TimelinePolicy, ToolClassification } from './types';

export const createDefaultToolClassifier =
  () =>
  (item: ToolUseItem): ToolClassification => {
    const resolved = resolveToolPresentation(item);
    const write = objectWriteFor(item.name);
    return {
      axis: resolved.axis === 'interaction' ? 'interaction' : 'activity',
      card: resolved.card !== undefined,
      groupable: resolved.groupable,
      ...(write
        ? {
            // Different tools can write the same kind of object (for example,
            // session documents from a template or pre-chart).
            groupKey: `object:${write.kind}:${write.action}`,
            minGroupSize: 2,
          }
        : {}),
    };
  };

export interface ProjectTimelinePolicyDeps {
  isVisibleUserMessage: TimelinePolicy['isVisibleUserMessage'];
  isSuppressedTodo: TimelinePolicy['isSuppressedTodo'];
  isSuppressedError: TimelinePolicy['isSuppressedError'];
  minGroupSize?: number;
}

export const createProjectTimelinePolicy = (
  deps: ProjectTimelinePolicyDeps
): TimelinePolicy => ({
  classify: createDefaultToolClassifier(),
  isVisibleUserMessage: deps.isVisibleUserMessage,
  isSuppressedTodo: deps.isSuppressedTodo,
  isSuppressedError: deps.isSuppressedError,
  minGroupSize: deps.minGroupSize,
});
